import { Anchor } from '../../../../shared/FormStyles/Button';

const DownloadCsv = () => {
  return (
    <Anchor
      variant="outlinedBlue"
      mr="8px"
      href="/client_admin/population_segments/download_csv"
      target="_blank"
    >
      Download
    </Anchor>
  );
};

export default DownloadCsv;
